import http from "../http-common";

class APIService {

  // get images by city
  getImages(city) {
    return http.get('/locations/'+city, {
    })
  }

}

export default new APIService();